"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *
 * Accessible Focus Button Component
 *
 * This button solves the accessibility problem with focus outline on buttons without a solid background
 *
 */
const AccessibleButton = _styledComponents.default.button`
    ${({
  mouseDownFocus
}) => mouseDownFocus && (0, _styledComponents.css)`
            &:focus {
                outline: 0 !important;
            }
        `}
`;

const AccessibleFocusButton = ({
  children,
  onMouseDown,
  onFocus,
  onBlur,
  mouseDownFocusPersist,
  ...otherProps
}) => {
  const [mouseDownFocus, setMouseDownFocus] = (0, _react.useState)(false);
  const [tabFocus, setTabFocus] = (0, _react.useState)(false);
  const [mouseDownFocusPersisted, setMouseDownFocusPersisted] = (0, _react.useState)(0);
  const handleMouseDown = (0, _react.useCallback)(e => {
    setMouseDownFocus(true);
    setTabFocus(false);
    setMouseDownFocusPersisted(mouseDownFocusPersist ? 2 : 0);

    if (onMouseDown) {
      onMouseDown(e);
    }
  }, [setMouseDownFocus, setMouseDownFocusPersisted, setTabFocus, onMouseDown, mouseDownFocusPersist]);
  const handleFocus = (0, _react.useCallback)(e => {
    if (mouseDownFocusPersisted === 0) {
      setTabFocus(true);
    } else {
      setMouseDownFocus(true);
      setTabFocus(false);
      setMouseDownFocusPersisted(mouseDownFocusPersisted => mouseDownFocusPersisted - 1);
    }

    if (onFocus) {
      onFocus(e);
    }
  }, [setMouseDownFocus, setMouseDownFocusPersisted, setTabFocus, onFocus]);
  const handleBlur = (0, _react.useCallback)(e => {
    setMouseDownFocus(false);
    setTabFocus(false);

    if (onBlur) {
      onBlur(e);
    }
  }, [setMouseDownFocus, setTabFocus, onBlur]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(AccessibleButton, {
    onMouseDown: handleMouseDown,
    onFocus: handleFocus,
    onBlur: handleBlur,
    mouseDownFocus: mouseDownFocus || mouseDownFocusPersisted > 0,
    tabFocus: tabFocus,
    ...otherProps,
    children: children
  });
};

AccessibleFocusButton.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.object]),
  mouseDownFocusPersist: _propTypes.default.bool
};
var _default = AccessibleFocusButton;
exports.default = _default;